export default {
  en: {
    pages: {
      home: 'Home',
      search: 'Search',
      restaurants: 'Restaurants',
      products: 'Menu',
      dish: 'Dish',
      restaurant: 'Restaurant',
      orders: 'Orders',
      order: 'Order',
      cart: 'Cart',
      payment: 'Payment',
      orderSuccess: 'Thank you',
      login: 'Sign in',
      register: 'Sign up',
      profile: 'Profile',
      address: 'Address',
      faq: 'FAQ',
      cuisine: 'Cuisine',
      invite: 'For partners',
      map: 'Map',
      finance: 'Finance',
      catalog: 'New product',
      shop: 'Shop',
      wallets: 'Wallets',
      wallet: 'Wallet',
      accounts: 'Accounts',
      account: 'Account',
      transactions: 'Transactions',
      operations: 'Operations',
      operation: 'Operation',
      users: 'Users',
      user: 'User',
    },
  },
  ru: {
    pages: {
      home: 'Главная',
      search: 'Поиск',
      restaurants: 'Рестораны',
      products: 'Меню',
      dish: 'Блюдо',
      restaurant: 'Ресторан',
      orders: 'Заказы',
      order: 'Заказ',
      cart: 'Корзина',
      payment: 'Оплата',
      orderSuccess: 'Спасибо за заказ',
      login: 'Вход',
      register: 'Регистрация',
      profile: 'Профиль',
      address: 'Адрес',
      faq: 'Вопрос-ответ',
      cuisine: 'Кухня',
      invite: 'Партнерам',
      map: 'Карта',
      finance: 'Финансы',
      catalog: 'Новый товар',
      shop: 'Магазин',
      wallets: 'Кошельки',
      wallet: 'Кошелёк',
      accounts: 'Счета',
      account: 'Счёт',
      transactions: 'Транзакции',
      operations: 'Операции',
      operation: 'Операция',
      users: 'Пользователи',
      user: 'Пользователь',
    },
  },
}
